const defaultImage = "/ecosafe-social-preview.jpg";

const defaultSocial = {
  type: "website",
  title: "ECOSAFE",
  description:
    "ECOSAFE provides professional training and consulting services. Transform your organization and individuals through development excellence.",
  images: [defaultImage],
};

export const SiteSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "ECOSAFE",
  description:
    "ECOSAFE provides professional training and consulting services across Saudi Arabia and beyond.",
  url: "https://ecosafe.com.sa",
  logo: "https://ecosafe.com.sa/logo.svg",
  sameAs: [
    "https://www.linkedin.com/company/ecosafe-for-training-and-consultancy-services/",
    "https://www.facebook.com/p/Ecosafe-for-Training-and-Consulting-61565045387866/",
    "https://www.instagram.com/ecosafe.sa",
  ],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Riyadh",
    addressCountry: "SA",
  },
};

export const WebSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "ECOSAFE",
  url: "https://ecosafe.com.sa",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://ecosafe.com.sa/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export const CourseSchema = ({
  title,
  description,
  duration,
  price,
  currency,
  instructor,
  startDate,
  endDate,
  city,
  country,
  image,
}) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  name: title,
  description,
  image,
  provider: {
    "@type": "Organization",
    name: "ECOSAFE",
    sameAs: "https://ecosafe.com.sa",
  },
  ...(price && {
    offers: {
      "@type": "Offer",
      category: "Paid",
      price,
      priceCurrency: currency,
    },
  }),
  hasCourseInstance: {
    "@type": "CourseInstance",
    courseMode: "Onsite",
    courseWorkload: duration,
    startDate,
    endDate,
    ...(instructor && { instructor: { "@type": "Person", name: instructor } }),
    location: {
      "@type": "Place",
      name: city,
      address: {
        "@type": "PostalAddress",
        addressLocality: city,
        addressCountry: country,
      },
    },
  },
});

export const OrganizationSchema = (overrides = {}) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  ...defaultSocial,
  ...overrides,
});

export const PageSchema = ({
  title,
  description,
  type = "WebPage",
}) => ({
  "@context": "https://schema.org",
  "@type": type,
  name: title,
  description,
});

export const generateScript = (type: keyof typeof schemaData, data: any) => {
  const baseData = schemaData[type](...(data || []));
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(baseData),
      }}
      type="application/ld+json"
    />
  );
};

const schemaData = {
  course: CourseSchema,
  organization: OrganizationSchema,
  page: PageSchema,
};

export default generateScript;